export var ANALYTICS_ACTION = {
  CLICK: 'click',
  VIEW: 'view',
  FILL_IN: 'fill_in'
};
export var ANALYTICS_OBJECT_TYPE = {
  WIDGET: 'widget',
  POPUP: 'popup'
};
export var ANALYTICS_ITEM_TYPE = {
  ITEM_TYPE: 'button',
  BANNER: 'banner',
  POPUP: 'popup',
  LINK: 'link',
  ICON: 'icon',
  TOGGLE: 'toggle',
  ELEMENT: 'element',
  TAB: 'tab',
  FIELD: 'field',
  MESSAGE: 'message',
  SELECTOR_ITEM: 'selector_item',
  BUTTON: 'button',
  FILTER: 'filter',
  RADIOBUTTON: 'radiobutton'
};
export var TARGET = {
  MAIN: 'главная',
  PROFILE: 'профиль'
};